var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMaximize4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/maximize-4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "maximize-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.165 10.1006C20.755 10.1006 20.415 9.76059 20.415 9.35059V4.10059H15.165C14.755 4.10059 14.415 3.76059 14.415 3.35059C14.415 2.94059 14.755 2.60059 15.165 2.60059H21.165C21.575 2.60059 21.915 2.94059 21.915 3.35059V9.35059C21.915 9.76059 21.575 10.1006 21.165 10.1006Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.16504 22.1006H3.16504C2.75504 22.1006 2.41504 21.7606 2.41504 21.3506V15.3506C2.41504 14.9406 2.75504 14.6006 3.16504 14.6006C3.57504 14.6006 3.91504 14.9406 3.91504 15.3506V20.6006H9.16504C9.57504 20.6006 9.91504 20.9406 9.91504 21.3506C9.91504 21.7606 9.57504 22.1006 9.16504 22.1006Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M13.6655 11.601C13.4755 11.601 13.2855 11.531 13.1355 11.381C12.8455 11.091 12.8455 10.611 13.1355 10.321L20.6355 2.82102C20.9255 2.53102 21.4055 2.53102 21.6955 2.82102C21.9855 3.11102 21.9855 3.59102 21.6955 3.88102L14.1955 11.381C14.0455 11.531 13.8555 11.601 13.6655 11.601Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M3.16547 22.101C2.97547 22.101 2.78547 22.031 2.63547 21.881C2.34547 21.591 2.34547 21.111 2.63547 20.821L10.1355 13.321C10.4255 13.031 10.9055 13.031 11.1955 13.321C11.4855 13.611 11.4855 14.091 11.1955 14.381L3.69547 21.881C3.54547 22.031 3.35547 22.101 3.16547 22.101Z",
    fill: "#757575"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaximize4);
export default __webpack_public_path__ + "static/media/maximize-4.b3c4c5fd7f865b0507ae042fed17a62d.svg";
export { ForwardRef as ReactComponent };